export const constant = {
  emailArticleButtonText: 'Email article',
  trackingMessage: 'emailArticle',
};
